<template>
    <div class="no-result">
        <dl class="empty_content">
            <dt>
                <img :src="require('@/assets/images/icon-empty-content@2x.png')" alt="" />
            </dt>
            <dd>
                <p class="no-result-text">{{title}}</p>
            </dd>
        </dl>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        iconClass: {
            type: String,
            default: ''
        }
    }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";
.no-result {
    text-align: center
}

.empty_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #fff;
    padding-bottom: rem2(100px);

    >dt {
        width: rem2(79px);
        height: rem2(52px);
        margin-top: rem2(60px);

        >img {
            width: 100%;
            height: 100%;
        }
    }

    >dd {
        margin-top: rem2(24px);
        font-size: rem2(13px);
        color: #939393;
    }
}
.no-result-text {
    color: #999;
}
</style>